import React, { useState, useEffect } from "react";
import { BiSolidLeftArrow, BiSolidRightArrow } from "react-icons/bi";
import { RiDoubleQuotesR } from "react-icons/ri";

export default function Testimonial({ testimonialimage, testimonialdata }) {
  const { heading, content, ShowInWebSite } = testimonialdata;

  const [startIndex, setStartIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(goToNextCards, 3000); // Adjust the interval duration here
    return () => clearInterval(interval);
  }, []);

  const goToPrevCards = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setStartIndex((prevIndex) => (prevIndex - 1 + content.length) % content.length);
      setIsTransitioning(false);
    }, 500); // Adjust the transition duration here
  };

  const goToNextCards = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setStartIndex((prevIndex) => (prevIndex + 1) % content.length);
      setIsTransitioning(false);
    }, 500); // Adjust the transition duration here
  };

  return (
    ShowInWebSite === 1 && (
      <div className="testimonial">
        <div className="testimonial-text">
          <p>
            {heading} <img src={testimonialimage} alt="heading circle" />
          </p>
        </div>

        <div className="testimonial-container">
          <div className="slider">
            {[0, 1, 2].map((i) => {
              const dataIndex = (startIndex + i) % content.length;
              const card = content[dataIndex];
              return (
                <div
                  key={i}
                  className={`testimonial-card ${
                    isTransitioning ? "transitioning" : ""
                  }`}
                >
                  <span className="testimonial-quote">
                    <RiDoubleQuotesR />
                  </span>
                  <p className="testimonial-name">{card.name}</p>
                  <p className="testimonial-lines">{card.desc}</p>
                </div>
              );
            })}
          </div>

          <div className="slider-btn-container">
            <button className="slider-btn-left" onClick={goToPrevCards}>
              <div className="slider-btn-left-cirle"></div>
              <span className="slider-btn-left-arrow">
                <BiSolidLeftArrow className="slider-btn-left-arrow-head" />
                <div className="slider-btn-left-arrow-tail"></div>
              </span>
            </button>
            <button className="slider-btn-right" onClick={goToNextCards}>
              <span className="slider-btn-right-arrow">
                <div className="slider-btn-right-arrow-tail"></div>
                <BiSolidRightArrow className="slider-btn-right-arrow-head" />
              </span>
              <div className="slider-btn-right-cirle"></div>
            </button>
          </div>
        </div>
      </div>
    )
  );
}
